wbApp.factory('holidayCalendarSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var HolidayCalendar = $resource('/restapi/holiday-calendars/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/holiday-calendars/:id' },
            'getBankHoliday': { method: 'GET', url: '/restapi/holiday-calendars/bank-holidays/country/:countryCode/year/:year' },
            'getAll': { method: 'GET', isArray: true, url: '/restapi/holiday-calendars' },
            'insert': { method: 'POST', url: '/restapi/holiday-calendars' },
            'update': { method: 'PUT', url: '/restapi/holiday-calendars/:id' },
            'delete': { method: 'DELETE', url: '/restapi/holiday-calendars/:id' }            
        });

        var holidayCalendars;

        function createNew() {
            var holidayCalendar = {
                isNew: true
            };

            return holidayCalendar;
        }

        function insert(model) {
            var result = repositorySvc.customPost(
                'insert',
                HolidayCalendar,
                model);

            result.$promise.then(function (entity) {
                repositorySvc.entityInserted(holidayCalendars, entity);
            });

            return result;
        }

        function remove(holidayCalendarId) {
            
            var result = repositorySvc.customDelete(
                'delete',
                HolidayCalendar,
                { id: holidayCalendarId });

            result.$promise.then(function () {
                repositorySvc.entityRemoved(holidayCalendars, holidayCalendarId);
            });

            return result;
        }

        function update(model) {
            
            var result = repositorySvc.customPutWithParams(
                'update',
                HolidayCalendar,
                { id: model.id },
                convertDatesToDateString(model));

            result.$promise.then(function () {
                repositorySvc.entityUpdated(holidayCalendars, model);
            });

            return result;
        }

        function getById(holidayCalendarId) {
            return repositorySvc.customGet('getById', HolidayCalendar, { id: holidayCalendarId });
        }

        function getBankHoliday(countryCode, year) {
            return repositorySvc.customGet('getBankHoliday', HolidayCalendar, { countryCode: countryCode, year: year });
        }

        function getAll(refresh) {
            if (!holidayCalendars || refresh) {
                holidayCalendars = repositorySvc.customGet('getAll', HolidayCalendar, {});
            }
            return holidayCalendars;
        }

        return {
            createNew: createNew,
            getById: getById,
            getBankHoliday: getBankHoliday,
            getAll: getAll,
            insert: insert,
            remove: remove,
            update: update,
        }
    }
]);